import { isString } from 'lodash';

import {
  TILE_DEFAULT_FONT_SIZE_VARIANT,
  TileGroup,
  TileGroupItem,
  TileVariant,
} from '@/components/diagrams/components/Tile';
import { Node } from '@/components/diagrams/FlowChart';

export function VisualizationGroupContents({
  members,
  hidden,
}: {
  members: Node[];
  hidden: boolean;
}) {
  if (hidden) return null;
  return (
    <TileGroup
      tileVariant={TileVariant.Default}
      fontSizeVariant={TILE_DEFAULT_FONT_SIZE_VARIANT}
      hideItemCount
    >
      {members.map((member) => (
        <TileGroupItem
          key={member.id}
          description={
            isString(member.data.lineOne) ? member.data.lineOne : member.id
          }
          value={
            isString(member.data.lineTwo) ? member.data.lineTwo : undefined
          }
          tileVariant={TileVariant.Default}
          fontSizeVariant={TILE_DEFAULT_FONT_SIZE_VARIANT}
        />
      ))}
    </TileGroup>
  );
}
